import {useEffect , useState} from 'react'
import util from "../../utils/utils";
import axios from 'axios';
import { useNavigate ,useLocation, useSearchParams} from 'react-router-dom';
import { Mail,ChevronsRight} from 'react-feather';
import useGetFullPolicy from '../Policy/hooks/useGetFullPolicy';
import useGetPolicyTimelineMindmap from '../Policy/hooks/useGetPolicyTimelineMindmap';
import {LoadingDiv } from '@components/LoadingDiv';
import { Markdown2Svg } from '@components/Markdown2Svg';
import {FullScreenMindTreeModal} from '@components/FullScreenMindTreeModal'

export const Share = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { pathname } = useLocation();
  const [fileName, setFileName] = useState('')
  const [mdTxt,setMdTxt] =useState('')

  useEffect(()=>{
    // const params = util.getSearchParamsFromHash()
    console.log(searchParams)
    setFileName(searchParams.get('fileName'))
  },[])


  const [upBtnVisible,setUpBtnVisible] = useState(false)
  const {getFullPolicyAction ,fullPolicyLoading} = useGetFullPolicy();
  const {getPolicyTimelineMindmapAction, policyTimelineMindmapLoading} = useGetPolicyTimelineMindmap();
  const [data,setData] =useState()
  const [viewPolicy, setViewPolicy] = useState()
  const [index,setIndex] = useState(0)

  useEffect(()=>{
    if(fileName){
        viewFullPolicyAction(fileName)
    }
},[fileName])
const viewFullPolicyAction = (item) => {
    reset();
    setFileName(item)
    getFullPolicyAction({policy_title:item,search_content:searchParams.get('searchContent')})
    .then(res=>{setData(res)});

    getPolicyTimelineMindmapAction({policy_title:item})
    .then(res=>{setViewPolicy(res);setMdTxt(res?.policy_mind_map?.replace(/\>+/g, '-') ?? '')})

}

useEffect(()=>{
    document.getElementById('sharePolicyContent')?.addEventListener('click', function(event) {
        if(event.target.tagName === 'A') {
            reset();
            viewFullPolicyAction(event.target.id?.replace(/《|》/g, ""))
        }
      });
},[])

useEffect(()=>{
    document.getElementById("shareFileContentScrollDiv")?.addEventListener("scroll",e=>{
        util?.throttle(setUpBtnStatus(),1000)
    })
},[])
const setUpBtnStatus = () => {
    let scrollTop = document.getElementById("shareFileContentScrollDiv")?.scrollTop
    // console.log(scrollTop)
    if(scrollTop > 800){
        setUpBtnVisible(true)
    }else{
        setUpBtnVisible(false)
    }
}
const reset = () => {
  setIndex(0);
  document.getElementById('shareTopAnchor').scrollIntoView()
}



const scrollIntoHightLight = (type) => {
    let containerElement = document.getElementById('sharePolicyContent')
    let childElements = containerElement.getElementsByClassName('bg-yellow-200');
    childElements[index]?.scrollIntoView({behavior: "smooth",block: "center", inline: "nearest"});
    if(type === 'forward'){
        setIndex((index + 1) % data?.high_light.length)
    }else if(type === 'back'){
        setIndex((index - 1) % data?.high_light.length)
    }
}

  
    return (
      <div class="h-screen bg-base-200 w-full flex flex-col overflow-auto">
        <FullScreenMindTreeModal
            fileName={fileName}
            txt={mdTxt}
            setFileName={setFileName}
            setMdTxt={()=>setMdTxt(viewPolicy?.policy_mind_map?.replace(/\>+/g, '-') ?? '')}

        />

        <div className="navbar bg-base-100 py-4 px-8 mb-2 max-w-[1980px] w-full mx-auto">
          <div className="flex-1">
          {searchParams && <a className="btn btn-ghost text-xl flex gap-2 items-center">
                <Mail className='text-primary' strokeWidth="3"/>
               <span> 来自 {searchParams.get('from')} 的分享:</span>
            </a>}
          </div>
          <div className="flex-none">
            <button className="btn btn-primary content-primary text-white text-lg" onClick={()=>navigate('/policy')}>
              体验更多功能
              <ChevronsRight size='15'/>
            </button>
          </div>
        </div>
        <div className='m-3 bg-base-100 flex-1 max-w-[1980px] w-full mx-auto'>
            {upBtnVisible && <div id="back-to-top" className="absolute bottom-16 right-16 z-10">
                <button className="btn btn-circle btn-outline bg-base-100" 
                    onClick={()=>{
                        let element = document.getElementById("shareFileContentScrollDiv");
                        element.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        })}
                    }
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l7.5-7.5 7.5 7.5m-15 6l7.5-7.5 7.5 7.5" />
                    </svg>
                </button>
            </div>}
            <div className="p-0 realtive w-full h-full" id="shareFileContentScrollDiv ">
                <div id="shareTopAnchor"></div>

                <div className="bg-white p-4 sticky top-0 z-10">
                    <div className={`flex space-between items-center`}>
                        {searchParams.get('searchContent') ? <div className='flex flex-1'>

                            <h2 className="card-title pl-4">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth='1.5' stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
                                </svg>
                                检索关联：{data?.high_light?.length}处
                            </h2>
                            <button className='ml-6' style={{transform: 'scaleX(-1)'}} disabled={index===0} onClick={()=>{scrollIntoHightLight('back')}}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" style={{opacity:index === 0 ? 0.3 : 1}}>
                                    <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
                                </svg>
                            </button>
                            <button className='mx-1' disabled={data?.high_light?.length ===0 } onClick={()=>{scrollIntoHightLight('forward')}}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" style={{opacity:data?.high_light?.length ===0 ? 0.3 : 1}}>
                                    <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
                                </svg>
                            </button>
                        </div> :
                        <h2 className="card-title pl-4 mr-6 flex-1">{fileName}</h2>
                        }
                    </div>
                </div>

                <div className="overflow-auto p-2 lg:px-8 lg:py-2 text-justify lg:flex lg:gap-6">
                    <div  className='flex-1 border mb-6'>
                        <div className="flex space-between items-center p-4 bg-base-200 ">
                            <h2 className="card-title flex-1">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />
                                </svg>

                                原文内容:
                            </h2>
                        </div>
                        <div id='sharePolicyContent' className='p-6'>
                            {
                                fullPolicyLoading || !data ? 
                                <>
                                <LoadingDiv/>
                                </> :
                                <>
                                        <div
                                            dangerouslySetInnerHTML={{ __html: data?.html_content }}
                                        />
                                        {/* <div dangerouslySetInnerHTML={{ __html: data?.high_light ? 
                                        util.HighlightText(data?.full_policy ?? data?.txt_full_content, data?.high_light)
                                        : data?.full_policy ?? data?.txt_full_content }}>
                                        </div> */}
                                </>
                            }
                        </div>

                    </div>
                    <div className='lg:w-2/5'>
                        <div className='border mb-6'>
                            <h2 className="card-title bg-base-200 p-4 border-b">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m21 7.5-2.25-1.313M21 7.5v2.25m0-2.25-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3 2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75 2.25-1.313M12 21.75V19.5m0 2.25-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25" />
                                </svg>
                               政策脉络 :
                            </h2>
                            <div className='relative p-4'>
                                {
                                    policyTimelineMindmapLoading || !viewPolicy ? 
                                    <>
                                    <LoadingDiv/>
                                    </> :
                                    <Markdown2Svg
                                    fileName={fileName}
                                    setFileName={setFileName}
                                    setMdTxt={()=>setMdTxt(viewPolicy?.policy_mind_map?.replace(/\>+/g, '-') ?? '')}
                                    divHeight='450px'
                                    txt={mdTxt}
                                    />
                                }
                            </div>
                        </div>
                        <div className="border mb-6">
                            <h2 className="card-title bg-base-200 p-4 border-b">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                </svg>
                               政策时间线分析 :
                            </h2>
                            {
                                policyTimelineMindmapLoading || !viewPolicy ? 
                                <div className='p-4'>
                                    <LoadingDiv/>
                                </div> :
                                <>
                                {
                                    viewPolicy?.time_line && 
                                    <ul className={`timeline timeline-snap-icon max-md:timeline-compact timeline-vertical  p-4 my-timeline`}>
                                    {viewPolicy?.time_line?.map(item =>
                                        <li>
                                            <div className="timeline-middle">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-5 w-5">
                                                <path fillRule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.75-11.25a.75.75 0 0 0-1.5 0v4.59L7.3 9.24a.75.75 0 0 0-1.1 1.02l3.25 3.5a.75.75 0 0 0 1.1 0l3.25-3.5a.75.75 0 1 0-1.1-1.02l-1.95 2.1V6.75Z" clipRule="evenodd" />
                                                </svg>
                                            </div>
                                            <div className="timeline-end mb-10">
                                                <time className="font-mono italic">{item?.policy_time?.split(' ')[0] ?? item?.policy_time}  {item?.from_organization}</time>
                                                <div className="text-lg font-black link link-primary" onClick={()=>{viewFullPolicyAction(item?.policy_title)}}>{item?.policy_title}</div>
                                            </div>
                                            <hr/>
                                        </li>
                                    )}
                                    </ul>
                                }
                                </>
                            }
                        </div>

                    </div>
                </div>
            </div>

        </div>
      </div>

    )
}